/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { useState } from "react";
import ActionButton from "./ActionButton";

const ClipboardCopyButton = ({
  className,
  copyValue = "",
  onCopy,
}) => {
  // copy state
  const [copied, setCopied] = useState(false);

  // handlers
  const handleClick = () => {
    // copy text to clipboard
    navigator.clipboard.writeText(copyValue);

    // set copy state
    setCopied(true);

    // handle callback
    onCopy?.();
  }

  const handleMouseOver = () => {
    // unset copied
    setCopied(false);
  };

  return (
    <ActionButton
      className={className}
      type="copy"
      tooltip={copied ? "Copied!" : "Copy"}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
    />
  );
};

export default ClipboardCopyButton;
